import { GenericBackendResponse } from '../genericBackendResponse';

export interface OnboardingStatusUser {
	id: string;
	email: string;
}

export interface OnboardingStatusData {
	totalCompanyUsers: number;
	completed: number;
	completedUsers: OnboardingStatusUser[];
	benefitDiscarded: number;
	benefitDiscardedUsers: OnboardingStatusUser[];
}

export type GetOnboardingStatusResponse = GenericBackendResponse<OnboardingStatusData>;

const getOnboardingStatus = async (token: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/companies/onboarding-status`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default getOnboardingStatus;
